// extracted by mini-css-extract-plugin
export default {"ssShellToggleButton":"ShellToggleButton_ssShellToggleButton__1XZkK"};